export const routes = [
  {
    path: '/termo-referencia',
    component: () => import(/* webpackChunkName: "reference-term" */ './components/List'),
    name: 'reference.term.list',
    meta: {
      requiresAuth: true
    }
  }
]
